import React, { useContext, useEffect, useRef, useState } from "react";
import { Button, Heading, ResumeTips, RichTextEditor, SectionHeading, SectionSamples } from "../../../components";
import Input from "../../../components/Input/Input";
import { ResumeContext } from "../../../contexts/resumeContext";
import styles from "./PersonalDetailsForm.module.css";
import {
  ChevronDown,
  ChevronUp,
  deleteIcon,
  InfoIcon,
  Spinner,
  User,
} from "../../../components/Icons/Icons";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { storage } from "../../../firebase";

function PersonalDetailsForm() {
  const { resumeInfo, setResumeInfo, updateResumeInfo, imgSupported } =
    useContext(ResumeContext);

  const [imgLoading, toggleImgLoading] = useState(false);
  const [additionalDetailsVisible, showAdditionalDetails] = useState(false);
  const [personalDetails, setPersonalDetails] = useState(
    resumeInfo?.personalDetails || {}
  );
  const [img, setImg] = useState(null);

  useEffect(() => {
    if(personalDetails && Object.keys(personalDetails).length){
      updateResumeInfo.current("personalDetails", personalDetails, resumeInfo);
    }
  }, [personalDetails]);

  useEffect(() => {
    if (resumeInfo?.personalDetails && !Object.keys(personalDetails).length)
      setPersonalDetails(resumeInfo.personalDetails);
  }, [resumeInfo]);

  const handleChange = (e) => {
    let personalDetailsTemp = { ...personalDetails };
    personalDetailsTemp[e.target.name] = e.target.value;
    setPersonalDetails(personalDetailsTemp);
  };

  const handleImage = async (e) => {
    const file = e.target?.files?.[0];
    if (file) {
      toggleImgLoading(true);
      const userImgRef = ref(storage, `user/${file.name}`);
      const snapshot = await uploadBytes(userImgRef, file);
      const url = await getDownloadURL(
        ref(storage, snapshot.metadata.fullPath)
      );

      handleChange({ target: { name: "userImage", value: url } });
      toggleImgLoading(false);
    }
    // const reader = new FileReader();
    // const url = reader.readAsDataURL(file);
    // reader.onloadend = (e) => {
    //   if (reader?.result) {
    //     handleChange({ target: { name: "userImage", value: reader.result } });
    //   }
    // };
    // setImg(url)
  };

  // const updateInfo = (newPersonalDetails) => {
  //   const resumeInfoTemp = { ...resumeInfo };
  //   resumeInfoTemp["personalDetails"] = { ...newPersonalDetails };
  //   setResumeInfo(resumeInfoTemp);
  // };

  return (
    <div>
      <SectionHeading content="Personal Details" section="PD"/>
      <div className="row">
        <div className="col">
          <Input
            label="Job Title"
            name="jobTitle"
            onChange={handleChange}
            value={personalDetails.jobTitle}
          />
        </div>
        <div className="col" style={{ paddingTop: 20 }}>
          {imgSupported ? <div style={{ display: "inline-block", position: "relative" }}>
            <input
              type="file"
              id="userImage"
              accept="image/*"
              style={{ display: "none" }}
              onChange={handleImage}
            />
            <label htmlFor="userImage" className={styles.userImageLabel}>
              {personalDetails?.userImage ? (
                <img src={personalDetails?.userImage} />
              ) : imgLoading ? (
                <Spinner className={styles.userIcon} />
              ) : (
                <User className={styles.userIcon} />
              )}
              {/* {"This template doesn't support image"} */}
              {personalDetails?.userImage ? "Change Image" : "Upload Image"}
            </label>
            {personalDetails?.userImage && (
              <button
                className="delete-btn"
                style={{ top: "0.75em" }}
                onClick={() =>
                  handleChange({ target: { name: "userImage", value: null } })
                }
              >
                <img src={deleteIcon} />
              </button>
            )}
          </div> : <div className={styles.userImageLabel} style={{cursor:'not-allowed'}}>
              <User className={styles.userIcon} /> This template doesn't support image
          </div>
          }
        </div>
      </div>
      <div className="row">
        <div className="col">
          <Input
            label="First Name"
            name="firstName"
            onChange={handleChange}
            value={personalDetails.firstName}
          />
        </div>
        <div className="col">
          <Input
            label="Last Name"
            name="lastName"
            onChange={handleChange}
            value={personalDetails.lastName}
          />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <Input
            label="Email"
            name="email"
            onChange={handleChange}
            value={personalDetails.email}
          />
        </div>
        <div className="col">
          <Input
            label="Phone"
            name="phone"
            type="number"
            onChange={handleChange}
            value={personalDetails.phone}
          />
        </div>
      </div>
      {additionalDetailsVisible && (
        <>
          <div className="row">
            <div className="col">
              <Input
                label="Address"
                name="address"
                onChange={handleChange}
                value={personalDetails.address}
              />
            </div>
            <div className="col">
              <Input
                label="Postal Code"
                name="postalCode"
                onChange={handleChange}
                value={personalDetails.postalCode}
              />
            </div>
          </div>
          {/* <div className="row">
            <div className="col">
              <Input
                label="Nationality"
                name="nationality"
                onChange={handleChange}
                value={personalDetails.nationality}
              />
            </div>
            <div className="col">
              <Input
                label="Date Of Birth"
                name="dob"
                onChange={handleChange}
                value={personalDetails.dob}
              />
            </div>
          </div> */}
        </>
      )}
      <button
        className="link"
        onClick={() => showAdditionalDetails(!additionalDetailsVisible)}
      >
        {additionalDetailsVisible ? "Hide" : "Add"} additional details{" "}
        {additionalDetailsVisible ? <ChevronUp /> : <ChevronDown />}
      </button>
      <div style={{ marginTop: 40 }}>
        <SectionHeading
          editable
          section="SUM"
          content="Professional Summary"
          subheading={<>Write 2-4 short & energetic sentences to interest the reader! Mention your role, experience & most importantly - your biggest achievements, best qualities and skills. <SectionSamples section="SUM"/></>}
        />
        <RichTextEditor
          onChange={(value) =>
            handleChange({ target: { name: "summary", value } })
          }
          value={personalDetails.summary}
          placeholder="e.g. 5+ years experienced Software Developer skilled in software development, debugging and programming..."
        />
      </div>
    </div>
  );
}

export default PersonalDetailsForm;
